module.exports = __webpack_public_path__ + "static/app-shot-1-5-1f02e6e2521ad5fe2044306ec7e7cc82.jpg";